import { createAsyncThunk } from '@reduxjs/toolkit';

import type { CriarSituacaoDto, EditarSituacaoDto } from '../types/situacaoArbitralTypes';
import { situacoesArbitralService } from './services';

export const fetchSituacoesArbitral = createAsyncThunk(
  'situacoesArbitral/fetch',
  async (_arg, { rejectWithValue }) => {
    try {
      return await situacoesArbitralService.listar();
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const fetchEscritoriosSituacao = createAsyncThunk(
  'situacoesArbitral/fetchEscritorios',
  async (_arg, { rejectWithValue }) => {
    try {
      return await situacoesArbitralService.listarEscritorios();
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const criarSituacaoArbitral = createAsyncThunk(
  'situacoesArbitral/criar',
  async (data: CriarSituacaoDto, { rejectWithValue }) => {
    try {
      return await situacoesArbitralService.criar(data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const editarSituacaoArbitral = createAsyncThunk(
  'situacoesArbitral/editar',
  async ({ id, data }: { id: string; data: EditarSituacaoDto }, { rejectWithValue }) => {
    try {
      return await situacoesArbitralService.editar(id, data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const alterarAtivacaoSituacaoArbitral = createAsyncThunk(
  'situacoesArbitral/ativacao',
  async ({ id, active }: { id: string; active: boolean }, { rejectWithValue }) => {
    try {
      return await situacoesArbitralService.definirAtivacao(id, active);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const atualizarEscritoriosSituacaoArbitral = createAsyncThunk(
  'situacoesArbitral/escritorios',
  async ({ id, escritorioIds }: { id: string; escritorioIds: string[] }, { rejectWithValue }) => {
    try {
      return await situacoesArbitralService.atualizarEscritorios(id, escritorioIds);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
